// @ts-nocheck
import { apiClient } from '../api-client';
import { CONTACTS } from '../../api-endpoints/api-endpoints';

export interface ApiContact {
  id: string;
  displayName: string | null;
  phone: string | null;
  email: string | null;
  company: string | null;
  createdAt: string;
}

export interface CreateContactInput {
  displayName: string;
  phone?: string | null;
  email?: string | null;
  company?: string | null;
}

export interface UpdateContactInput {
  displayName?: string;
  email?: string | null;
  company?: string | null;
}

export const contactsService = {
  list: (q?: string): Promise<{ data: ApiContact[]; count: number }> =>
    apiClient.get(CONTACTS.list + (q ? `?q=${encodeURIComponent(q)}` : '')),

  create: (body: CreateContactInput): Promise<ApiContact> =>
    apiClient.post(CONTACTS.create, body),

  update: (id: string, body: UpdateContactInput): Promise<ApiContact> =>
    apiClient.patch(CONTACTS.update(id), body),

  remove: (id: string): Promise<{ removed: boolean }> =>
    apiClient.delete(CONTACTS.delete(id)),
};
